<script>
import { v4 as uuidv4 } from 'uuid'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'date-input.generic',
  props: {
    value: { type: [String, Number] },
    id: { type: String, default: () => uuidv4() },
    label: { type: String },
    labelColsSm: { type: String, default: '12' },
    labelColsMd: { type: String },
    labelColsLg: { type: String },
    labelColsXl: { type: String },
    width: { type: [String, Number] },
    maxWidth: { type: [String, Number] },
    textAlign: { type: String, default: 'left' },
    append: { type: String },
    prepend: { type: String },
    onlyShowError: { type: Boolean, default: true },
    hideErrorMessages: { type: Boolean, default: false },
    hideValidationIcon: { type: Boolean, default: true },
    isValid: { type: Boolean, default: true },
    errorMessages: { type: Array },
    number: { type: Boolean, default: false },
    description: { type: String },
    locale: { type: String, default: 'da' },
    weekday: { type: Number, default: 1 }
  },
  methods: {
    onInputHandler (v) {
      v = isEmpty(v) ? null : v
      this.$emit('input', v)
    }
  }
}
</script>
<template>
  <b-form-group
    :label-for="id"
    :label-cols-sm="labelColsSm"
    :label-cols-md="labelColsMd"
    :label-cols-lg="labelColsLg"
    :label-cols-xl="labelColsXl"
    class="d-flex align-items-center"
    :class="{
      'is-invalid': !isValid,
      'is-valid': isValid && !onlyShowError
    }"
    :description="description"
  >
    <template v-slot:label>
      <div v-if="!!label || !!$slots.label">
        <slot name="label">
          <div class="d-flex align-items-center pointer">
            {{ label }}
          </div>
        </slot>
      </div>
    </template>
    <b-input-group :prepend="prepend" :append="append">
      <slot name="prepend"></slot>
      <b-form-datepicker
        :id="id"
        v-bind="$attrs"
        v-on:focus="$event.target.select()"
        v-on="$listeners"
        :value="value"
        :style="{ maxWidth, width, textAlign }"
        :locale="locale"
        :start-weekday="weekday"
        :date-format-options="{
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        }"
        :class="{
          'is-invalid': !isValid,
          'is-valid': isValid && !onlyShowError,
          'hide-icon': hideValidationIcon
        }"
        :aria-describedby="`err_${id}`"
      ></b-form-datepicker>
      <slot name="append"></slot>
    </b-input-group>
    <b-form-invalid-feedback
      :id="`err_${id}`"
      v-if="!isValid && !hideErrorMessages"
    >
      <slot name="errors">
        <template v-if="!errorMessages">Fix this field</template>
        <template v-else>
          <span
            class="d-block"
            v-for="(err, idx) in errorMessages"
            :key="`err_${id}_${idx}`"
            >{{ err }}</span
          >
        </template>
      </slot>
    </b-form-invalid-feedback>
  </b-form-group>
</template>
